module.exports = __webpack_public_path__ + "images/newerp_button2.1787648603550.png";